/* Custom content map is intended to be used in conjunction with custom content videos */
const customContentMap = {
  // beautyrest_innovations_in_sleep
  '65233': {
    partnerName: 'Beautyrest',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/partners/beautyrest_logo_square.jpg',
    partnerDescription:
      'Beautyrest is a leading innovator of sleep and is dedicated to the pursuit of new ways to upgrade your nights, so you can always get the most from your day.'
  },
  // dropbox_how_one_team_turned_a_sprint_project_into_a_marathon_success
  '35352': {
    partnerName: 'Dropbox',
    partnerAvatarUrl:
      'https://pb-assets.tedcdn.com/system/baubles/files/000/007/428/original/dropbox_logo.jpg?1549990957',
    partnerDescription:
      'Dropbox is a modern collaborative workspace with a mission to design a more enlightened way of working. They build tools to help teams better work together.'
  },
  // the_north_face_the_next_step_in_the_evolution_of_clothing
  '58623': {
    partnerName: 'The North Face',
    partnerAvatarUrl:
      'https://pb-assets.tedcdn.com/system/baubles/files/000/008/323/original/North-Face-Logo.png?1581536816',
    partnerDescription:
      'The North Face fundamental mission remains unchanged since 1966: provide the best gear for our athletes and the modern day explorer, support the preservation of the outdoors, and inspire a global movement of exploration.'
  },
  // ben_pring_the_new_jobs_of_the_future_and_other_insights_on_the_changing_workforce
  '63685': {
    partnerName: 'Cognizant',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/cognizant_logo_square.png',
    partnerDescription:
      'Cognizant has helped pave the way for businesses large and small to transition their workforce and operations into the digital world.'
  },
  // sunil_prashara_how_complex_global_organizations_are_adapting_to_our_new_reality
  '63919': {
    partnerName: 'Project Management Institute',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/pmi_logo_square_better.png',
    partnerDescription:
      'Through global advocacy, collaboration, education and research, Project Management Institute (PMI) is the world’s leading association for those who consider project, program or portfolio management their profession.'
  },
  // rich_lesser_how_businesses_can_plan_for_the_road_to_recovery
  '64407': {
    partnerName: 'BCG',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/bcg_logo_square.png',
    partnerDescription:
      'A pioneer in business strategy, Boston Consulting Group partners with leaders in business and society to tackle their most important challenges and capture their greatest opportunities.'
  },
  // james_ludwig_how_organizations_can_create_safe_inviting_workplaces_for_returning_employees
  '64571': {
    partnerName: 'Steelcase',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/steelcase_logo_square.jpg',
    partnerDescription:
      'For more than 105 years, Steelcase Inc. has helped create great experiences for the world’s leading organizations across industries with a comprehensive portfolio of architecture, furniture and technology products and services.'
  },
  // craig_silliman_how_covid_19_impacted_a_global_tech_company_and_spurred_innovation
  '64723': {
    partnerName: 'Verizon',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/verizon_logo_square.png',
    partnerDescription:
      'Verizon Communications Inc. was formed on June 30, 2000 and is celebrating its 20th year as one of the world’s leading providers of technology, communications, information and entertainment products and services. Verizon is Headquartered in New York City with a presence around the world.'
  },
  // ahmad_hasnah_rethinking_education_and_celebrating_the_arabic_language
  '64916': {
    partnerName: 'Qatar Foundation',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/qatar_foundation_logo_square.png',
    partnerDescription:
      'Qatar Foundation for Education, Science, and Community Development (QF) is a non-profit organization that supports Qatar on its journey to becoming a diversified and sustainable economy. QF strives to serve the people of Qatar and beyond by providing specialized programs across its innovation-focused ecosystem of education, research and development, and community development.'
  },
  // joanne_s_bass_what_female_military_leadership_can_teach_us_about_overcoming_self_doubt
  '68177': {
    partnerName: 'USAF',
    partnerAvatarUrl: 'https://pl.tedcdn.com/partners/usaf_logo_square.png',
    partnerDescription:
      'For 75 years, the Air Force has broken barriers through diversity, speed, reach, precision and the boundaries of space. Innovative Airmen continue to protect the homeland through unrivaled air and space dominance across the globe. Air Force values of Integrity First, Service Before Self and Excellence in All We Do define our people and operations.'
  },
  // anja_blacha_how_a_world_record_mountaineer_empowers_youth_to_overcome_fear
  '68351': {
    partnerName: 'Project Management Institute',
    partnerAvatarUrl:
      'https://pl.tedcdn.com/build_back_better/pmi_logo_square_better.png',
    partnerDescription:
      'Through global advocacy, collaboration, education and research, Project Management Institute (PMI) is the world’s leading association for those who consider project, program or portfolio management their profession.'
  },
  // monday_com_relief_to_recovery
  '82380': {
    partnerName: 'monday.com',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/Monday_logo_square.png',
    partnerDescription:
      'monday.com is a cloud-based platform that allows companies to create their own applications and work management software. Its mission is to democratizes the power of software so organizations can easily build software applications and work management tools that fit their needs.'
  },
  // the_hartford_the_small_business_hustle
  '82609': {
    partnerName: 'The Hartford',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/Hartform_logo_square.png',
    partnerDescription:
      'The Hartford believes opening a small business is a big achievement. For over 30 years, we’ve been helping to protect the legacies and livelihoods of small business owners.'
  },
  // american_family_insurance_human_centered_justice
  '85999': {
    partnerName: 'American Family Insurance',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/american_family_insurance_logo.png',
    partnerDescription:
      'American Family Insurance is committed to inspiring, protecting and restoring dreams. With this purpose comes the responsibility to ensure that everyone has the ability and access to make their dreams  possible. Over the next five years, they are investing $105 million as part of the Free to Dream initiative to bridge equity gaps, build healthy, sustainable communities and fight for social justice.'
  },
  // american_family_insurance_one_company_at_a_time
  '86000': {
    partnerName: 'American Family Insurance',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/american_family_insurance_logo.png',
    partnerDescription:
      'American Family Insurance is committed to inspiring, protecting and restoring dreams. With this purpose comes the responsibility to ensure that everyone has the ability and access to make their dreams possible. Over the next five years, they are investing $105 million as part of the Free to Dream initiative to bridge equity gaps, build healthy, sustainable communities and fight for social justice.'
  },
  // robert_a_belle_our_emotions_and_our_money
  '87393': {
    partnerName: 'T. Rowe Price',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/troweprice_logo.png',
    partnerDescription:
      'T. Rowe Price offers a strategic investing approach to help you build the future you want with confidence.'
  },
  // david_schonthal_david_schonthal_custom_video_for_upwork_the_way_we_work
  '108272': {
    partnerName: 'Upwork',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/upwork_green_logo.png',
    partnerDescription:
      'Upwork is the world’s work marketplace that connects businesses with independent talent. They serve everyone from one-person startups to large, Fortune 100 enterprises with a trust-driven platform that enables companies and talent to work together in new ways that unlock their potential.'
  },
  // shari_davis_shari_davis_custom_sponsored_video_for_visit_philly
  '118794': {
    partnerName: 'Visit Philadelphia',
    partnerAvatarUrl:
      'https://ted-conferences-general-web-assets.s3.amazonaws.com/programmer_tool/media/vp_logo_square.png',
    partnerDescription:
      "As the United States approaches the nation's 250th birthday in 2026, Visit Philadelphia is committed to highlighting the birthplace of the country's constant pursuit of a more perfect union.",
    blurb:
      'Made possible with the support of Visit Philadelphia, and created by the TED Ideas Studio, the branded content arm of TED Partnerships'
  }
};

export default customContentMap;
